import './fsl-admin.scss';
import './plugin-settings/settings';

jQuery( document ).ready( function () {
	const $ = jQuery;

	const { ajaxurl } = devnet_fsl_admin_ajax;

	/**
	 *
	 * HELPER FUNCTIONS
	 *
	 */

	const updateMarginLabels = ( selectedPosition, marginRows ) => {
		const nbPosition = selectedPosition.val();

		if ( nbPosition ) {
			const nbPositions = nbPosition.split( '-' );
			marginRows.get().forEach( ( row, i ) => {
				const label = $( row ).find( 'th label' );
				const updatedLabel = label.find( 'span' );
				const position = nbPositions[ i ].toUpperCase();
				const marginPositionHTML = `<span class="devnet-text-change">${ position }</span>`;

				if ( updatedLabel.length ) {
					updatedLabel.replaceWith( marginPositionHTML );
				} else {
					label.append( `<span>${ position }</span>` );
				}
			} );
		}
	};

	function handleBarTypeChange( barTypeSelect, insideCircleSelect, barType ) {
		const groupID = barTypeSelect.closest( '.group' ).attr( 'id' );
		const $group = $( `#${ groupID }` );

		const $insideCircleRow = insideCircleSelect.closest( 'tr' );
		const $circleSizeRow = $group.find( 'tr.circle_size' );
		const $iconRow = $group.find( 'tr.icon' );
		const $iconColorRow = $group.find( 'tr.icon_color' );
		const $circleBgColorRow = $group.find( 'tr.circle_bg_color' );
		const $barBorderColorRow = $group.find( 'tr.bar_border_color' );
		const $barHeightRow = $group.find( 'tr.bar_height' );
		const $barRadiusRow = $group.find( 'tr.bar_radius' );
		const $removeStripesRow = $group.find( 'tr.remove_bar_stripes' );
		const $disableAnimationRow = $group.find( 'tr.disable_animation' );
		const $disabledAnimationsRow = $group.find( 'tr.disabled_animations' );

		const $indicatorIconRow = $group.find( 'tr.indicator_icon' );
		const $indicatorIconSizeRow = $group.find( 'tr.indicator_icon_size' );
		const $indicatorIconShapeRow = $group.find( 'tr.indicator_icon_shape' );
		const $indicatorIconBgColorRow = $group.find(
			'tr.indicator_icon_bg_color'
		);

		if ( barType === 'circular' ) {
			$circleSizeRow.show();
			$insideCircleRow.show();
			$circleBgColorRow.show();
			$barBorderColorRow.hide();
			$barHeightRow.hide();
			$barRadiusRow.hide();
			$removeStripesRow.hide();
			$disableAnimationRow.hide();
			$disabledAnimationsRow.hide();

			$indicatorIconRow.hide();
			$indicatorIconSizeRow.hide();
			$indicatorIconShapeRow.hide();
			$indicatorIconBgColorRow.hide();

			if ( insideCircleSelect.val() === 'icon' ) {
				$iconRow.show();
				$iconRow.removeClass( 'hide-option-row' );
				$iconColorRow.show();
				$iconColorRow.removeClass( 'hide-option-row' );
			} else {
				$iconRow.hide();
				$iconColorRow.hide();
			}
		} else {
			$circleSizeRow.hide();
			$insideCircleRow.hide();
			$circleBgColorRow.hide();
			$iconRow.hide();
			$iconColorRow.hide();
			$barBorderColorRow.show();
			$barHeightRow.show();
			$barRadiusRow.show();
			$removeStripesRow.show();
			$disableAnimationRow.show();
			$disabledAnimationsRow.show();

			$indicatorIconRow.show();
			$indicatorIconShapeRow.show();

			if (
				$( `[name="${ groupID }[indicator_icon]"]` ).is( ':checked' )
			) {
				$indicatorIconSizeRow.show();
				$indicatorIconBgColorRow.show();
				$iconRow.show();
				$iconColorRow.show();
			} else {
				$indicatorIconSizeRow.hide();
				$indicatorIconBgColorRow.hide();
			}
		}
	}

	function handleInsideCircleChange( insideCircleSelect, insideCircle ) {
		const barType = insideCircleSelect
			.closest( 'table' )
			.find( '.bar_type select' )
			.val();

		if ( 'circular' !== barType ) {
			return false;
		}

		const iconRow = insideCircleSelect.closest( 'tr' ).next( '.icon' );
		const iconColorRow = iconRow.next( '.icon_color' );

		if ( insideCircle === 'icon' ) {
			iconColorRow.show();
			iconRow.show();
		} else {
			iconColorRow.hide();
			iconRow.hide();
		}
	}

	function fieldName( section = '', name = '' ) {
		return `[name="devnet_fsl_${ section }${ name }"]`;
	}

	function handleFieldVisibilityOrDisable(
		checkbox,
		targetField,
		disable = true
	) {
		const $checkboxElement = $( checkbox );
		const targetFields = Array.isArray( targetField )
			? targetField
			: [ targetField ];

		function toggleVisibilityOrDisable( $targetFieldElement ) {
			const $parentElement = $targetFieldElement.parent(
				'.dvnt-group-field'
			).length
				? $targetFieldElement.parent( '.dvnt-group-field' )
				: $targetFieldElement.closest( 'tr' );

			if ( disable ) {
				$targetFieldElement.prop(
					'disabled',
					$checkboxElement.is( ':checked' )
				);
			} else if ( $checkboxElement.is( ':checked' ) ) {
				$parentElement.show();
				$parentElement.removeClass( 'hide-option-row' );
			} else {
				$parentElement.hide();
				$parentElement.addClass( 'hide-option-row' );
			}
		}

		targetFields.forEach( ( target ) => {
			const $targetFieldElement = $( target );
			toggleVisibilityOrDisable( $targetFieldElement ); // Initial setup

			$checkboxElement.on( 'change', () =>
				toggleVisibilityOrDisable( $targetFieldElement )
			);
		} );
	}

	function handleFieldVisibilityByValue(
		fieldSelector,
		expectedValue,
		targetField,
		invert = false
	) {
		const $fieldElement = $( fieldSelector );
		const targetFields = Array.isArray( targetField )
			? targetField
			: [ targetField ];

		function toggleVisibility( $targetFieldElement ) {
			const $parentElement = $targetFieldElement.parent(
				'.dvnt-group-field'
			).length
				? $targetFieldElement.parent( '.dvnt-group-field' )
				: $targetFieldElement.closest( 'tr' );

			const isMatch = $fieldElement.val() === expectedValue;
			const shouldShow = invert ? ! isMatch : isMatch;

			if ( shouldShow ) {
				$parentElement.show().removeClass( 'hide-option-row' );
			} else {
				$parentElement.hide().addClass( 'hide-option-row' );
			}
		}

		targetFields.forEach( ( target ) => {
			const $targetFieldElement = $( target );
			toggleVisibility( $targetFieldElement ); // Initial setup

			$fieldElement.on( 'change', () =>
				toggleVisibility( $targetFieldElement )
			);
		} );
	}

	function inheritedSettings( baseName ) {
		const $inheritSettingsField = $(
			`[name="${ baseName }[inherit_progress_bar_settings]"]`
		);
		const inheritSettings = $inheritSettingsField.is( ':checked' );

		const isInherited = $inheritSettingsField.length && inheritSettings;

		return isInherited;
	}

	function barType( baseName, isType ) {
		const $barType = $( `[name="${ baseName }[bar_type]"]` );
		const type = $barType.val();

		// If not defined second isType argument, return barType name/value.
		if ( ! isType ) {
			return type;
		}

		return isType === type;
	}

	/** end - Helper Funstions */

	/**
	 *
	 * COMMON (mostly bar) listeners
	 *
	 */

	// // Handle 'inherit_progress_bar_settings' for each matching element
	// $( '[name^="devnet_fsl_"][name$="[inherit_progress_bar_settings]"]' ).each(
	// 	function () {
	// 		const $inheritSettingsRow = $( this ).closest(
	// 			'tr.inherit_progress_bar_settings'
	// 		);

	// 		// Determine related barType and insideCircle based on current element's base name
	// 		const baseName = this.name.replace(
	// 			'[inherit_progress_bar_settings]',
	// 			''
	// 		);
	// 		const $barType = $( `[name="${ baseName }[bar_type]"]` );
	// 		const $insideCircle = $( `[name="${ baseName }[inside_circle]"]` );

	// 		// Initially hide/show based on checked state
	// 		if ( $( this ).is( ':checked' ) ) {
	// 			$inheritSettingsRow.nextAll().hide();
	// 		}

	// 		// Attach change event listener to handle show/hide logic
	// 		$( this ).on( 'change', function () {
	// 			if ( $( this ).is( ':checked' ) ) {
	// 				$inheritSettingsRow.nextAll().hide();
	// 			} else {
	// 				$inheritSettingsRow.nextAll().show();
	// 				handleBarTypeChange(
	// 					$barType,
	// 					$insideCircle,
	// 					$barType.val()
	// 				);
	// 				handleInsideCircleChange(
	// 					$insideCircle,
	// 					$insideCircle.val()
	// 				);
	// 			}
	// 		} );
	// 	}
	// );

	// Handle 'bar_type' and 'inside_circle' changes for each matching element
	// NOTE: must be before `indicator_icon` check!
	$( '[name^="devnet_fsl_"][name$="[bar_type]"]' ).each( function () {
		const $barType = $( this );
		const baseName = this.name.replace( '[bar_type]', '' );
		const $insideCircle = $( `[name="${ baseName }[inside_circle]"]` );

		if ( ! inheritedSettings( baseName ) ) {
			// Initialize the bar type change
			handleBarTypeChange( $barType, $insideCircle, $barType.val() );
		}

		// Attach change event listener for bar type
		$barType.on( 'change', function () {
			handleBarTypeChange( $barType, $insideCircle, this.value );
		} );
	} );

	// Loop through each checkbox and handle visibility or disabling for related fields
	// NOTE: must be after `bar_type` check!
	$( '[name^="devnet_fsl_"][name$="[indicator_icon]"]' ).each( function () {
		const baseName = this.name.replace( '[indicator_icon]', '' );

		if (
			! inheritedSettings( baseName ) &&
			barType( baseName, 'linear' )
		) {
			handleFieldVisibilityOrDisable(
				`[name="${ this.name }"]`,
				[
					`[name="${ baseName }[indicator_icon_size]"]`,
					`[name="${ baseName }[indicator_icon_shape]"]`,
					`[name="${ baseName }[indicator_icon_bg_color]"]`,
					`[name="${ baseName }[icon]"]`,
					`[name="${ baseName }[icon_color]"]`,
				],
				false
			);
		}
	} );

	// Handle 'inside_circle' changes for each matching element
	$( '[name^="devnet_fsl_"][name$="[inside_circle]"]' ).each( function () {
		const $insideCircle = $( this );
		const baseName = this.name.replace( '[inside_circle]', '' );
		const $barType = $( `[name="${ baseName }[bar_type]"]` );

		if ( ! inheritedSettings( baseName ) ) {
			// Initialize the inside circle change
			handleInsideCircleChange( $insideCircle, $insideCircle.val() );
		}

		// Attach change event listener for inside circle
		$insideCircle.on( 'change', function () {
			handleInsideCircleChange(
				$insideCircle,
				this.value,
				$barType.val()
			);
		} );
	} );

	// Loop through each checkbox and handle visibility or disabling for related fields
	$( '[name^="devnet_fsl_"][name$="[disable_animation]"]' ).each(
		function () {
			const baseName = this.name.replace( '[disable_animation]', '' );

			if (
				! inheritedSettings( baseName ) &&
				barType( baseName, 'linear' )
			) {
				handleFieldVisibilityOrDisable(
					`[name="${ this.name }"]`,
					`[name="${ this.name.replace(
						'[disable_animation]',
						'[disabled_animations]'
					) }"]`,
					false
				);
			}
		}
	);

	/** end - common (bar) listeners */

	/**
	 *
	 * GENERAL SETTINGS
	 *
	 */

	const $customThreshold = $(
		'[name="devnet_fsl_general[custom_threshold]"]'
	);
	const $customThresholdPerMethod = $(
		'[name^="devnet_fsl_general\\[custom_threshold_per_method\\]"]'
	);
	const customThresholdValue = $customThreshold.val();

	const customThresholdPerMethodHasValue =
		$customThresholdPerMethod.filter( function () {
			return $( this ).val() !== '';
		} ).length > 0;

	if (
		( ! customThresholdValue || customThresholdValue == 0 ) &&
		! customThresholdPerMethodHasValue
	) {
		$customThreshold.addClass( 'disabled' );
		$customThresholdPerMethod.addClass( 'disabled' );
	}

	$( document ).on(
		'change',
		'[name="devnet_fsl_general[enable_custom_threshold]"]',
		function () {
			if ( $( this ).is( ':checked' ) ) {
				$customThreshold.removeClass( 'disabled' );
				$customThresholdPerMethod.removeClass( 'disabled' );
			} else {
				$customThreshold.addClass( 'disabled' );
				$customThreshold.attr( 'value', '' );

				$customThresholdPerMethod.addClass( 'disabled' );
				$customThresholdPerMethod.attr( 'value', '' );
			}
		}
	);

	const $multilingual = $( '[name="devnet_fsl_general[multilingual]"]' );
	const $textInputs = $( `
	input[type="text"][name^="devnet_fsl_"][name$="[title]"], 
	input[type="text"][name^="devnet_fsl_"][name$="[description]"], 
	input[type="text"][name^="devnet_fsl_"][name$="[qualified_message]"], 
	input[type="text"][name^="devnet_fsl_"][name$="[text]"],
	input[type="text"][name^="devnet_fsl_"][name$="[label]"]
	` );

	if ( $multilingual.is( ':checked' ) ) {
		$textInputs.addClass( 'disabled multilingual' );
	} else {
		$textInputs.removeClass( 'disabled multilingual' );
	}

	$textInputs.each( function () {
		if ( $( this ).hasClass( 'disabled multilingual' ) ) {
			$( this ).after(
				'<div class="devnet-visible-tooltip">Multilingual option is active!</div>'
			);
		}
	} );

	/** end - General Settings */

	/**
	 *
	 * PROGRESS BAR
	 *
	 */

	$( 'tr[class^="shortcode_info"] input' ).replaceWith(
		'<input type="text" class="fsl-shortcode" value=\'[fsl-progress-bar]\' readonly>'
	);

	$( document ).on( 'click', 'input.fsl-shortcode', function ( e ) {
		/* Select the text field */
		$( this ).select();
		$( this )[ 0 ].setSelectionRange(
			0,
			$( this ).val().length
		); /* For mobile devices */
	} );

	/** end - Progress Bar */

	/**
	 *
	 * Gift Bar
	 *
	 */

	const giftProduct = $( '[name="devnet_fsl_gift_bar[gift_product]"]' );

	if ( typeof $.fn.select2 === 'function' ) {
		giftProduct.select2( {
			ajax: {
				url: ajaxurl,
				dataType: 'json',
				delay: 250, // delay in ms while typing when to perform a AJAX search
				data( params ) {
					return {
						q: params.term, // search query
						action: 'devnet_fsl_search', // AJAX action for admin-ajax.php
						searchIn: [ 'product', 'product_variation' ], // Additional parameter
					};
				},
				processResults( data ) {
					const options = [];
					if ( data ) {
						// data is the array of arrays, and each of them contains ID and the Label of the option
						$.each( data, function ( index, text ) {
							// do not forget that "index" is just auto incremented value
							options.push( {
								id: `${ text[ 2 ] }---${ text[ 0 ] }___${ text[ 1 ] }`,
								text: text[ 1 ],
								selected: true,
							} );
						} );
					}

					return {
						results: options,
					};
				},
				cache: true,
			},
			minimumInputLength: 3, // the minimum of symbols to input before perform a search
		} );
	}

	handleFieldVisibilityByValue(
		'[name="devnet_fsl_gift_bar[after_threshold]"]',
		'cart',
		'[name="devnet_fsl_gift_bar[price_display]"]'
	);

	/** end - Gift Bar */

	/**
	 *
	 * NOTICE BAR
	 *
	 */

	const nbPositionField = $( '[name="devnet_fsl_notice_bar[position]"]' );
	const nbMarginRows = $(
		'#devnet_fsl_notice_bar tr.margin_y, #devnet_fsl_notice_bar tr.margin_x'
	);

	updateMarginLabels( nbPositionField, nbMarginRows );

	$( nbPositionField ).on( 'change', function ( e ) {
		updateMarginLabels( $( this ), nbMarginRows );
	} );

	/** end - Notice Bar */

	/**
	 *
	 * PRODUCT LABEL
	 *
	 */

	const plExclude = $( '[id="devnet_fsl_label[exclude]"]' );

	if ( typeof $.fn.select2 === 'function' ) {
		plExclude.select2( {
			ajax: {
				url: ajaxurl,
				dataType: 'json',
				delay: 250, // delay in ms while typing when to perform a AJAX search
				data( params ) {
					return {
						q: params.term, // search query
						action: 'devnet_fsl_search', // AJAX action for admin-ajax.php
						searchIn: [ 'product', 'category' ], // Additional parameter
					};
				},
				processResults( data ) {
					const options = [];
					if ( data ) {
						// data is the array of arrays, and each of them contains ID and the Label of the option
						$.each( data, function ( index, text ) {
							// do not forget that "index" is just auto incremented value
							options.push( {
								id: `${ text[ 2 ] }---${ text[ 0 ] }___${ text[ 1 ] }`,
								text: text[ 1 ],
								selected: true,
							} );
						} );
					}

					return {
						results: options,
					};
				},
				cache: true,
			},
			minimumInputLength: 3, // the minimum of symbols to input before perform a search
		} );
	}

	const plOverImage = $( '[name="devnet_fsl_label[label_over_image]"]' );
	const plPositionOptions = [
		'#devnet_fsl_label tr.position',
		'#devnet_fsl_label tr.margin_y',
		'#devnet_fsl_label tr.margin_x',
	];

	if ( plOverImage.is( ':checked' ) ) {
		plPositionOptions.forEach( ( option ) => {
			$( option ).show();
		} );
	} else {
		plPositionOptions.forEach( ( option ) => {
			$( option ).hide();
		} );
	}

	$( plOverImage ).on( 'change', function () {
		if ( $( this ).is( ':checked' ) ) {
			plPositionOptions.forEach( ( option ) => {
				$( option ).show();
			} );
		} else {
			plPositionOptions.forEach( ( option ) => {
				$( option ).hide();
			} );
		}
	} );

	const plPositionField = $( '[name="devnet_fsl_label[position]"]' );
	const plMarginRows = $(
		'#devnet_fsl_label tr.margin_y, #devnet_fsl_label tr.margin_x'
	);

	updateMarginLabels( plPositionField, plMarginRows );

	$( plPositionField ).on( 'change', function ( e ) {
		updateMarginLabels( $( this ), plMarginRows );
	} );

	const plTextLabelRows = [
		//'#devnet_fsl_label tr.multilingual',
		'#devnet_fsl_label tr.text',
		'#devnet_fsl_label tr.text_color',
		'#devnet_fsl_label tr.bg_color',
		'#devnet_fsl_label tr.hide_border_shadow',
	];

	const plImageEnable = $( '[name="devnet_fsl_label[enable_image_label]"]' );
	const plImageRow = $( '#devnet_fsl_label tr.image' );
	const plImageWidthRow = $( '#devnet_fsl_label tr.image_width' );

	if ( plImageEnable.is( ':checked' ) ) {
		plImageRow.show();
		plImageWidthRow.show();

		plTextLabelRows.forEach( ( row ) => {
			$( row ).addClass( 'disabled' );
		} );
	} else {
		plImageRow.hide();
		plImageWidthRow.hide();

		plTextLabelRows.forEach( ( row ) => {
			$( row ).removeClass( 'disabled' );
		} );
	}

	$( plImageEnable ).on( 'change', function () {
		if ( plImageEnable.is( ':checked' ) ) {
			plImageRow.show();
			plImageWidthRow.show();

			plTextLabelRows.forEach( ( row ) => {
				$( row ).addClass( 'disabled' );
			} );
		} else {
			plImageRow.hide();
			plImageWidthRow.hide();

			plTextLabelRows.forEach( ( row ) => {
				$( row ).removeClass( 'disabled' );
			} );
		}
	} );

	/** end - Product Label */
} );
